'use strict';
module.exports = require('../../full/object/values');



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/features/object/values.js
// module id = 357
// module chunks = 0